import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
    // Retrieve user data from localStorage
    const userData = JSON.parse(localStorage.getItem('BondTimeLoginUserData'));

    // Check if user is logged in and has "Success" status
    const isAuthenticated = userData && userData[0]?.Userlogin === "Sucess";

    return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
